import { styled } from "@mui/material/styles";

// Components
import { Card } from "@mui/material";

const styledName = "Card";

export const StyledCard = styled(Card, { name: styledName })({
  "&": {
    borderRadius: "20px",
    padding: "25px 50px",
    minWidth: "420px",
    maxWidth: "500px",
    height: "fit-content",
    transition: `all 0.3s ease-in`
  },
});
